import React from "react";
import { ContextProviderComponent } from "./Context.js";
import GlobalStyle from "styles/globalStyles.js";
import styled from "styled-components";
import Nav from "components/global/nav/Nav.js";
import Footer from "components/global/Footer.js";
import { Seo } from "components/global/Seo.js";
const MainWrapper = styled.main`
  position: relative;
`;

const Index = ({ data, children, pageContext }) => {
  const locale = pageContext?.locale || "en";
  const langPageSlug = pageContext?.langPageSlug || "/";

  return (
    <MainWrapper>
      <ContextProviderComponent>
        <GlobalStyle />
        <Nav langLink={langPageSlug} locale={locale} />
        {children}
        <Footer locale={pageContext.locale} />
      </ContextProviderComponent>
    </MainWrapper>
  );
};

export default Index;

export const Head = () => <></>;
